<template>
  <v-container grid-list-md class="report-page">
    <v-row no-gutters class="report-range">
      <v-col cols="12">
        <DateTimePicker :range="true" v-model="dateTime" @submit="getAll()" :hideTime="true"
          :defaultRange="selectedRange" />
        <!-- <DateTimePicker
          :defaultRange="selectedRange"
          :range="true"
          :hideTime="true"
          @submit="getAll()"
          v-model="dateTime"
          class="mx-2"
          :showSelectedDate="true"
        /> -->
      </v-col>
    </v-row>
    <!-- {{selectedRange}} - {{dateTime}} -->

    <v-subheader class="report-heading">
      <v-row align-content="center" justify="space-between">
        <div>
          <small>Time and attendance</small>
          <h2>Employee report</h2>
        </div>
        <v-spacer></v-spacer>

        <Create v-if="employeeAccess.timeClock && employeeAccess.timeClock.create" @submit="dataSave"
          @error="dataError" />
      </v-row>
    </v-subheader>

    <SearchBar
      ref="searchInput"
      v-model="search"
      :hideBackBtn="true"
      class="report-search"
    />
    <v-row class="report-summary">
      <v-btn v-if="!isMobile" @click="print()" rounded small dark color="primary">Print</v-btn>
      <v-spacer></v-spacer>
      <h4 v-if="timeClockList.length > 0" class="report-total">
        <span v-if="employeeAccess.report && employeeAccess.report.showPay">
          <small>Total payroll</small>
          {{ grandTotal_total | currency }}
        </span>
      </h4>
    </v-row>

    <v-card class="touch-view-container report-list" flat outlined>
      <div class="center-content" v-if="loading">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
        <div class="ml-2">Loading employee hours</div>
      </div>
      <div v-if="filteredItems.length">
        <template v-for="(employee, index) in filteredItems">
          <div :key="employee.id" @click="open(employee)"
            class="report-row"
            :class="[index % 2 === 0 ? 'even-background' : 'odd-background']">
            <v-layout row wrap align-center class="mr-2 pointer">
              <v-flex>
                <div class="report-row__name text-capitalize">
                  {{ employee.name }} <v-chip v-if="employee.payOverTime" label color="blue" small text-color="white">
                    Overtime Active
                  </v-chip> <br />
                  <span class="caption" v-if="employeeAccess.report && employeeAccess.report.showHours">{{
                    secondsToHms(employee.totalSeconds) }}</span>
                </div>
              </v-flex>
              <v-flex shrink class="text-right">
                <h2 class="report-row__pay"
                  v-if="employeeAccess.report && employeeAccess.report.showPay">
                  {{ pay(employee) | currency }}
                </h2>
                <div class="report-row__records">
                  <span v-if="employee.TimeClocks.length > 1">Records: </span>
                  <span v-else>Record: </span>
                  <span>{{ employee.TimeClocks.length }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </div>
        </template>
      </div>

      <div class="text-center center-content" v-else>
        <div v-if="!loading">No attendance records found for the selected date</div>
      </div>


    </v-card>

    <v-dialog v-model="showPdf" width="700">
      <v-card style="height: 800px">
        <v-toolbar class="elevation-0">
          <v-toolbar-title class="subheading">Hours Summary</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="showPdf = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout fill-height column>
          <embed id="embedPDF" :src="pdf" type="application/pdf" height="100%" width="100%" />
        </v-layout>
      </v-card>
    </v-dialog>
    <ReportDetail v-if="selectedRow" @close="detailReportDialog = false" :EmployeeId="selectedRow.id"
      :mainDialog="detailReportDialog" :dateTime="dateTime" :empData="selectedRow" />
  </v-container>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service";
import DateTimePicker from "@/components/DateTimePicker.vue";
import locationService from "@/modules/Location/service.js";
import Create from "@/modules/Reports/components/Create.vue";
import pdfMake from 'pdfmake/build/pdfmake.min';
import { pdfMake as pdfFonts } from 'pdfmake/build/vfs_fonts';
import { mapActions, mapGetters } from "vuex";
import ReportDetail from "@/modules/Reports/components/DetailReports.vue";
// import EventBus from '@/event-bus';

pdfMake.vfs = pdfFonts.vfs;
export default {
  data() {
    return {
      loading: false,
      search: "",
      selectedRow: null,
      showSearch: false,
      detailReportDialog: false,
      timeClockList: [],
      shiftDuration: null,
      totalTime: 0,
      employeeData: null,
      selectedEmployees: [],
      employees: [],
      defaultRange: null,
      location: null,
      pdf: null,
      showPdf: false,
      // start: this.$moment().startOf("week").toISOString(),
      // end: this.$moment().endOf("week").toISOString(),
      dateTime: {
        start: this.$moment().startOf("week").toISOString(),
        end: this.$moment().endOf("week").toISOString(),
      },
      doc: {
        content: []
      }
    };
  },
  components: {
    DateTimePicker,
    ReportDetail,
    Create,
  },
  activated() {
    // console.log("this.$route.params", this.$route.params);
    if (this.$route.params && this.$route.params.reload) {
      this.getAll();
    }
  },
  created() {
    this.getAll();
    let localLocation = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );


    if (localLocation) {
      localLocation = JSON.parse(localLocation);

      locationService.Terminal.getById(localLocation.id).then(response => {
        this.location = response.data
        if (this.location && this.location.metadata && this.location.metadata.isLocked) {
          this.$router.push({
            name: "no-subscription",
            params: {
              location: this.Location,
            },
          });
        }
      })
    }
  },
  watch: {
    dateTime(val) {
      this.selectedRange = val.range;
    },
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
    ...mapGetters("global", ["getSelectedRange"]),
    isMobile() {
      // Define a threshold width (e.g., 768 pixels) to distinguish between mobile and desktop
      const thresholdWidth = 768;

      // Check if the window width is less than the threshold to determine if it's a mobile device
      return window.innerWidth < thresholdWidth;
    },
    getStart() {
      if (this.defaultRange) return null
      return this.start
    },
    getEnd() {
      if (this.defaultRange) return null
      return this.end
    },
    filteredItems() {
      if (this.search) {
        // return this.timeClockList.filter((item) => {
        //   return (
        //     item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        //   );
        // });
        return this.timeClockList
          .filter((item) => {
            return item.name.toLowerCase().includes(this.search.toLowerCase());
          })
          .sort((a, b) => {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          });
      } else {
        // console.log('this.timeClockList saqib', this.timeClockList)
        // Convert array to object with 'id' as the key
        const objectFromArray = this.timeClockList.reduce((acc, item) => {
          acc[item.id] = item; // Assuming each item has a unique 'id'
          return acc;
        }, {});

        // Convert object back to array and sort by 'name'
        const sortedArray = Object.values(objectFromArray).sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });

        return sortedArray;
        // return this.timeClockList
      }
    },
    selectedRange: {
      get() {
        return this.getSelectedRange;
      },
      set(val) {
        this.setSelectedRange(val);
        // if (!val) {
        //   this.product = null;
        //   return false;
        // }
      },
    },
    grandTotal_total() {
      let totalEarned = 0;

      if (this.timeClockList) {
        this.timeClockList.map((row) => {
          // let secondRate =  row.hourlyRate / 60 / 60.

          if (row.TimeClocks.length > 0) {
            if (row.metadata && row.metadata.timeClockLogin && row.metadata.timeClockLogin.fullDayEmployee) {
              totalEarned += this.fullDayPay(row)
            } else {
              row.TimeClocks.map((time) => {
                if (time.clockOutTime && row.hourlyRate) {
                  totalEarned +=
                    parseFloat(time.shiftDuration.totalInHours) *
                    parseFloat(row.hourlyRate);
                }
              });
            }
          }
        });
      }
      return totalEarned;
    },
  },
  methods: {
    ...mapActions("global", ["setSelectedRange"]),
    print() {
      this.createDocument()
      this.showPdf = true
    },
    async createDocument() {
      this.doc.content = []
      if (this.location) {
        this.doc.content.push({
          text: this.location.name,
          alignment: 'center',
          fontSize: 20,
          margin: [0, 0, 0, 20]
        });

      }
      this.doc.content.push(
        {
          alignment: 'justify',
          margin: [0, 0, 0, 5],
          columns: [
            {
              text: `Date: ${this.$moment(this.dateTime.start).format('MM/DD/YYYY')} to ${this.$moment(this.dateTime.end).format('MM/DD/YYYY')}`,
              alignment: 'left'
            },
            {
              text: `Total: ${this.$options.filters.currency(this.grandTotal_total)}`,
              alignment: 'right'
            }
          ]
        });
      // this.$options.filters.currency(this.invoice.subTotal),
      // this.doc.content.push({
      //   text: `Total: ${this.$options.filters.currency(this.grandTotal_total)}`,
      //   alignment: 'right',
      //   margin: [0, 2, 0, 2],
      // });
      if (this.timeClockList.length > 0) {
        let employeeList = [
          [
            {
              text: 'Name',
              alignment: 'center',
            },
            {
              text: 'Entry',
              alignment: 'center',
            },
            {
              text: 'Pay',
              alignment: 'center',
            }]
        ]
        this.timeClockList.map(emp => {
          employeeList.push(
            [
              {
                text: this.capitalize(emp.name).toString() + '\n' + this.secondsToHms(emp.totalSeconds).toString(),
                alignment: 'left',
                valign: 'middle'
              },
              {
                text: emp.TimeClocks.length.toString(),
                alignment: 'center',
                valign: 'middle'
              },
              {
                text: this.$options.filters.currency(this.pay(emp)),
                alignment: 'right',
                valign: 'middle'
              },
            ]
          )
        })
        this.doc.content.push(
          {
            table: {
              widths: ['*', 50, 100],
              body: employeeList
            },
          },
        )
      }
      this.doc.content.push({
        text: `Print: ${this.$moment().format('MM/DD/YYYY')}`,
        alignment: 'right',
        margin: [0, 2, 0, 2],
      });
      pdfMake.createPdf(this.doc).getDataUrl(data => {
        this.pdf = data;
      });
    },
    capitalize(str, lower = false) {
      if (str) {
        return (lower ? str.toLowerCase() : str).replace(
          /(?:^|\s|["'([{])+\S/g,
          (match) => match.toUpperCase(),
        );
      }
      return str;
    },
    openCloseSearch() {
      // console.log("askdjfal;ksjdf;lsad", this.$refs);
      if (this.showSearch) {
        // console.log("closing");
        this.showSearch = false;
      } else {
        // console.log("open");
        this.showSearch = true;
      }
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    // pay(val) {
    //   let totalCash = 0;
    //   if (val && val.TimeClocks.length > 0) {
    //     if (val.metadata && val.metadata.timeClockLogin && val.metadata.timeClockLogin.fullDayEmployee) {
    //       totalCash = this.fullDayPay(val)
    //     } else {
    //       val.TimeClocks.map((row) => {
    //         if (row.clockOutTime) {
    //           totalCash +=
    //             parseFloat(row.shiftDuration.totalInHours) * val.hourlyRate;
    //         }
    //       });
    //     }
    //   }
    //   return totalCash;
    // },
    pay(val) {
      let totalCash = 0;
      let totalHoursWorked = 0; // Track total worked hours

      if (val && val.TimeClocks.length > 0) {
        if (val.metadata && val.metadata.timeClockLogin && val.metadata.timeClockLogin.fullDayEmployee) {
          totalCash = this.fullDayPay(val);
        } else {
          val.TimeClocks.forEach((row) => {
            if (row.clockOutTime) {
              totalHoursWorked += parseFloat(row.shiftDuration.totalInHours);
            }
          });

          // Standard pay calculation
          if (val.payOverTime) {
            // Define when overtime starts (default 40 hours)
            let overtimeStart = val.startOverTime || 40;

            if (totalHoursWorked > overtimeStart) {
              let regularHours = overtimeStart;
              let overtimeHours = totalHoursWorked - overtimeStart;

              totalCash = (regularHours * val.hourlyRate) + (overtimeHours * val.overTimeRate);
            } else {
              totalCash = totalHoursWorked * val.hourlyRate;
            }
          } else {
            totalCash = totalHoursWorked * val.hourlyRate;
          }
        }
      }

      return totalCash;
    },
    fullDayPay(val) {
      const totalHoursByDate = {};
      let totalCash = 0;
      val.TimeClocks.forEach((row) => {
        if (row.clockOutTime) {
          const date = this.$moment(row.clockOutTime).format('YYYY-MM-DD');
          const totalHours = parseFloat(row.shiftDuration.totalInHours);
          // Check if the date already exists in the totalHoursByDate object
          if (totalHoursByDate[date]) {
            totalHoursByDate[date] += totalHours;
          } else {
            // If it doesn't exist, create a new entry with the total hours value
            totalHoursByDate[date] = totalHours;
          }
        }
      });
      Object.entries(totalHoursByDate).forEach(([totalHours]) => {
        // console.log("date ", date)
        if (val.metadata.timeClockLogin && totalHours >= parseInt(val.metadata.timeClockLogin.workingHours)) {
          totalCash += val.metadata.timeClockLogin.fullDayRate ? parseFloat(val.metadata.timeClockLogin.fullDayRate) : 0;
        } else if (val.metadata.timeClockLogin && totalHours >= parseInt(val.metadata.timeClockLogin.halfDayHours)) {
          totalCash += val.metadata.timeClockLogin.fullDayRate ? parseFloat(val.metadata.timeClockLogin.fullDayRate) / 2 : 0;
        }
      });
      return totalCash;
    },
    open(val) {
      // console.log('open click was work', val, this.detailReportDialog)
      if (val) {
        // return this.$router.push({
        //   name: "employee-detailReport",
        //   params: { id: val.id, empData: val, dateTime: this.dateTime },
        // });
        this.selectedRow = val;
        this.detailReportDialog = true;
      }
    },
    // hours(val) {
    //   // let hours = null;
    //   // console.log('hours', val)
    //   let shiftDuration = null
    //   if (val && val.TimeClocks.length > 0) {
    //     val.TimeClocks.map(row => {
    //       let to = (row.clockOutTime) ? row.clockOutTime : this.$moment()
    //       shiftDuration = this.duration(row.clockInTime, to)
    //       if (!row.clockOutTime) {
    //         shiftDuration.dateString = shiftDuration.dateString.concat(' *')
    //       }
    //       // hours += shiftDuration.totalInSeconds;
    //     })
    //   }
    //   return shiftDuration.dateString;
    // },
    duration(from, to) {
      var durationInSeconds = Math.abs(new Date(to) - new Date(from)) / 1000;
      return this.convertIntoDuration(durationInSeconds);
    },
    convertIntoDuration(durationInSeconds) {
      let result = {
        hours: null,
        minutes: null,
        seconds: null,
        totalInSeconds: durationInSeconds,
        totalInHours: durationInSeconds / 3600,
        dateString: null,
      };

      if (result) {
        // calculate hours
        result.hours = Math.floor(durationInSeconds / 3600);
        //subtract hours
        durationInSeconds -= result.hours * 3600;
        // calculate minutes
        result.minutes = Math.floor(durationInSeconds / 60) % 60;
        //subtract minutes
        durationInSeconds -= result.minutes * 60;
        // calculate seconds
        result.seconds = (durationInSeconds % 60).toFixed(0);
        // concatenating hours minutes and seconds
        result.dateString = `${result.hours}h ${result.minutes}m `;
        return result;
      }
    },
    // loadEmployees() {
    //   employeeService
    //     .getAll({
    //       limit: 100,
    // 		})
    // 		.then(response => {
    // 			this.employees = response.data;
    // 		})
    // 		.catch(error => {
    // 			throw error;
    // 		})
    // },
    dataSave() {
      this.dialog = false;
      this.$toast.success("Time entry saved", { timeout: 2000 });
      this.getAll();
    },
    dataError(e) {
      console.log("errdataErrordataErroror", e);
      this.$toast.error("Can't save entry, check date and time", {
        timeout: 2000,
      });
    },
    async getAll() {
      this.timeClockList = [];
      this.loading = true;
      timeClockService
        .getEmployees({
          employees: this.selectedEmployees,
          start: this.dateTime.start,
          end: this.dateTime.end,
        })
        .then(async (response) => {
          // console.log("response getEmployees", this.dateTime, response);
          this.loading = false;
          if (this.employeeAccess.onlyView) {
            const timeClock = response.data;
            await Promise.all(
              timeClock.map((row) => {
                this.employeeAccess.onlyViewEmployee.map((emp) => {
                  if (emp === row.id) {
                    this.timeClockList.push(row);
                  }
                });
              })
            );
          } else {
            this.timeClockList = response.data;
          }

          this.timeClockList.map((row) => {
            let totalSeconds = 0;
            row.TimeClocks.map((timeRow) => {
              if (timeRow.clockOutTime) {
                totalSeconds += timeRow.shiftDuration.totalInSeconds;
              }
            });
            row.totalSeconds = totalSeconds;
          });

        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
  },
};
</script>
<style scoped>
.report-page {
  max-width: 960px;
  padding-top: 18px;
  padding-bottom: 84px;
}

.report-range {
  margin: 0 0 14px !important;
}

.report-heading {
  height: auto;
  min-height: 66px;
  padding: 0 4px;
  color: inherit;
}

.report-heading small,
.report-heading h2 {
  display: block;
}

.report-heading small {
  color: #7f91a9;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1.1px;
  text-transform: uppercase;
}

.report-heading h2 {
  margin: 2px 0 0;
  color: inherit;
  font-size: 22px;
  letter-spacing: -0.4px;
}

.report-search {
  margin-bottom: 10px !important;
}

.report-search ::v-deep .v-input__slot {
  min-height: 52px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 14px !important;
  background: var(--v-surface-base) !important;
}

.report-summary {
  min-height: 62px;
  margin: 0 0 10px !important;
  padding: 6px 4px;
  align-items: center;
}

.report-total {
  margin: 0;
  color: inherit;
  font-size: 20px;
  font-weight: 750;
  text-align: right;
}

.report-total small {
  display: block;
  color: #7f91a9;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.9px;
  text-transform: uppercase;
}

.report-list {
  overflow: auto;
  border: 1px solid rgba(148, 163, 184, 0.15) !important;
  border-radius: 16px !important;
  background: var(--v-surface-base) !important;
}

.report-row {
  min-height: 80px;
  padding: 9px 12px;
  background: transparent !important;
  cursor: pointer;
  transition: background 120ms ease;
}

.report-row:hover {
  background: rgba(96, 165, 250, 0.07) !important;
}

.report-row.even-background,
.report-row.odd-background {
  background: transparent !important;
}

.report-row__name {
  color: inherit;
  font-size: 15px;
  font-weight: 700;
}

.report-row__name .caption {
  color: #94a3b8;
  font-weight: 500;
}

.report-row__pay {
  margin: 0;
  color: inherit;
  font-size: 18px !important;
  font-weight: 700;
}

.report-row__records {
  margin-top: 4px;
  color: var(--v-accent-base);
  font-size: 12px;
  font-weight: 700;
}

.report-row ::v-deep .v-divider {
  border-color: rgba(148, 163, 184, 0.12) !important;
}

.touch-view-container {
  height: auto;
  max-height: calc(100vh - 318px);
  overflow: auto;
  width: 100%;
}

@media (max-width: 600px) {
  .report-page {
    padding: 12px 12px 76px;
  }

  .report-heading {
    min-height: 58px;
  }

  .report-heading h2 {
    font-size: 20px;
  }

  .report-summary {
    min-height: 52px;
  }

  .report-list {
    border-radius: 14px !important;
  }

  .report-row {
    min-height: 86px;
    padding: 10px 8px;
  }

  .report-row__name {
    font-size: 14px;
  }

  .report-row__pay {
    font-size: 16px !important;
  }

  .touch-view-container {
    height: auto;
    max-height: calc(100vh - 306px);
  }
}
</style>
